module.exports = __webpack_public_path__ + "img/pizza_five_eighths_96px1_sabor.fw.519b6ca5.png";